/***
 * /////////////////////////////////////////
 * フォーム妥当性確認  (Using the validate.js library)
 * -------------------------
 *
 * /addresses 用のフォームバリデータです。
 *
 * Validate.js と /util/ValidateUtil.js を使ってバリデーションを設定します。
 * バリデーションルールについてはこちらをご覧ください。
 * https://validatejs.org/#validators
 *
 * すべてのフォーム検証属性はここに格納され、ビューコンポーネントから直接呼び出されます。
 * //////////////////////////////////////////
 */

/**
 * 住所更新・追加フォーム妥当性確認
 */
export const addressStoreValidation = {
    postal_code1: {
        presence: true,
        numericality: {only_integer: true},
        length: {is: 3},
    },
    postal_code2: {
        presence: true,
        numericality: {only_integer: true},
        length: {is: 4},
    },
    state: {
        presence: true,
        length: {maximum: 80}
    },
    city: {
        presence: true,
        length: {maximum: 40}
    },
    address: {
        presence: true,
        length: {maximum: 255}
    }
}
